import React from 'react'
import { ChevronDownIcon } from '@heroicons/react/24/outline'
import { useCallback, useState, useEffect } from 'react'
import Image from 'next/image'
import { useMediaQuery } from '@mantine/hooks'
import styles from './kdt-bebj-17th.module.scss'

const BenefitAccordion = () => {
  const isMobile = useMediaQuery('(max-width: 1023px)')
  const [isOpen1, setIsOpen1] = useState(true)
  const [isOpen2, setIsOpen2] = useState(false)

  useEffect(() => {
    if (!isMobile) {
      setIsOpen1(true)
      setIsOpen2(true)
    } else {
      setIsOpen1(true)
      setIsOpen2(false)
    }
  }, [isMobile])

  const onOpenHandler1 = useCallback(() => {
    if (isMobile) {
      setIsOpen1(prev => !prev)
    }
  }, [isMobile])

  const onOpenHandler2 = useCallback(() => {
    if (isMobile) {
      setIsOpen2(prev => !prev)
    }
  }, [isMobile])

  return (
    <>
      <li
        className="group w-full list-none overflow-hidden rounded-lg bg-[#333] px-4 py-6 lg:w-auto lg:flex-1 lg:px-8 lg:py-7"
        onClick={isMobile ? onOpenHandler1 : undefined}
      >
        <div className="flex w-full cursor-pointer items-center justify-between gap-x-3 lg:cursor-default">
          <div className="flex flex-col gap-2">
            <p className="text-base font-bold leading-normal text-white lg:text-2xl">
              ICT 기업 <b className="max-w-fit text-yellow-450">인턴십</b> 기회
            </p>
          </div>
          {isMobile && (
            <ChevronDownIcon
              className={`${
                isOpen1 ? 'rotate-180 transform' : ''
              } ml-auto h-auto w-4 shrink-0 grow-0 text-white lg:w-8`}
            />
          )}
        </div>
        {/* open */}
        {isOpen1 && (
          <div
            className={`mt-5 flex w-full flex-1 flex-col ${!isMobile || isOpen1 ? '' : 'hidden'}`}
          >
            <div className="mb-2 text-sm font-semibold text-label-assistive lg:mb-3 lg:text-base">
              채용안내
            </div>
            <dl className="flex w-full flex-col gap-3 rounded bg-[#404040] p-4 lg:gap-5 lg:p-6">
              <dt className="text-sm leading-normal text-label-assistive lg:text-base lg:font-semibold">
                채용 시, 과제 전형 100% 면제!
              </dt>
              <div
                className="flex flex-col gap-3 border-t border-label-neutral pt-3 lg:gap-2 lg:pt-5"
                role="group"
              >
                <dd className="text-sm leading-normal text-label-assistive lg:text-base lg:font-semibold">
                  [채용 프로세스]
                  <br />
                  기업 프로젝트 수행 → 실무자 평가 → <br className="block lg:hidden" />
                  우수 수료생 선정 → 인턴 채용
                </dd>
              </div>
            </dl>
            <div className="mb-2 mt-5 text-sm font-semibold text-label-assistive lg:mb-3 lg:mt-6 lg:text-base">
              기업소개
            </div>
            <dl className="flex w-full flex-col gap-3 rounded bg-[#404040] p-4 lg:min-h-[832px] lg:gap-5 lg:p-6">
              <dt className="w-[186px] lg:w-[380px]">
                <Image
                  src={`https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/benefit_accordion_img1_${
                    isMobile ? 'm' : 'pc'
                  }.png`}
                  layout="fill"
                  objectFit="cover"
                  className="!relative z-10 w-full object-cover"
                  alt="-"
                />
              </dt>
              <div
                className="flex flex-col gap-3 border-t border-label-neutral pt-3 lg:gap-2 lg:pt-5"
                role="group"
              >
                <dd className="text-sm leading-normal text-label-assistive lg:text-base lg:font-semibold">
                  [모멘티]
                  <br />
                  웹사이트 및 어플리케이션 제작 에이전시
                </dd>
                <dd className="text-sm leading-normal text-label-assistive lg:text-base lg:font-semibold">
                  [카이토리]
                  <br />
                  컴퓨터시스템 통합/구축 서비스업 및<br />
                  AR/VR 시스템/콘텐츠 제작업
                </dd>
                <dd className="text-sm leading-normal text-label-assistive lg:text-base lg:font-semibold">
                  [하들소프트]
                  <br />
                  컴퓨터 시스템 통합 자문 구축 및 서비스업
                </dd>
              </div>
            </dl>
          </div>
        )}
      </li>
      <li
        className="group w-full list-none overflow-hidden rounded-lg bg-[#333] px-4 py-6 lg:w-auto lg:flex-1 lg:px-8 lg:py-7"
        onClick={isMobile ? onOpenHandler2 : undefined}
      >
        <div className="flex w-full cursor-pointer items-center justify-between gap-x-3 lg:cursor-default">
          <div className="flex flex-col gap-2">
            <p className="text-base font-bold leading-normal text-white lg:text-2xl">멋사 로켓단</p>
          </div>
          {isMobile && (
            <ChevronDownIcon
              className={`${
                isOpen2 ? 'rotate-180 transform' : ''
              } ml-auto h-auto w-4 shrink-0 grow-0 text-white lg:w-8`}
            />
          )}
        </div>
        {/* open */}
        {isOpen2 && (
          <div
            className={`mt-5 flex w-full flex-1 flex-col ${!isMobile || isOpen2 ? '' : 'hidden'}`}
          >
            <div className="mb-2 text-sm font-semibold text-label-assistive lg:mb-3 lg:text-base">
              멋사 로켓단 프로젝트 사진
            </div>
            <dl className="flex w-full flex-col gap-3 rounded bg-[#404040] p-4 lg:gap-5 lg:p-6">
              <dt className="w-full">
                <Image
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendj-17th/benefit_accordion_img2.png"
                  layout="fill"
                  objectFit="cover"
                  className="!relative z-10 w-full object-cover"
                  alt="-"
                />
              </dt>
            </dl>
            <div className="mb-2 mt-5 text-sm font-semibold text-label-assistive lg:mb-3 lg:mt-6 lg:text-base">
              활동내용
            </div>
            <dl className="flex w-full flex-col gap-3 rounded bg-[#404040] p-4 lg:gap-5 lg:p-6">
              <dt className="text-sm leading-normal text-label-assistive lg:text-base lg:font-semibold">
                프론트엔드 등 다양한 직무의 개발자들과 함께, 실무와 동일한 협업 환경에서 약 3개월 간
                백엔드 프로젝트를 진행합니다.
              </dt>
              <div
                className="flex flex-col gap-3 border-t border-label-neutral pt-3 lg:pt-5"
                role="group"
              >
                <dd className="text-sm leading-normal text-label-assistive lg:text-base lg:font-semibold">
                  [프로젝트 진행 중]
                  <br />
                  기업 프로젝트 수행 → 실무자 평가 → <br className="block lg:hidden" />
                  우수 수료생 선정 → 인턴 채용
                </dd>
                <dd
                  className={`${styles.text_dot} ${styles.text_dot_benefit_accordion} text-sm leading-normal text-label-assistive lg:text-base lg:font-semibold`}
                >
                  기획/설계
                  <div className="mt-1 flex flex-col gap-0.5">
                    <p
                      className={`${styles.text_dot} ${styles.text_dot_benefit_accordion_2depth} text-sm leading-normal text-label-assistive lg:text-base lg:font-semibold`}
                    >
                      요구 사항 정의 → 개발 범위 확정
                    </p>
                    <p
                      className={`${styles.text_dot} ${styles.text_dot_benefit_accordion_2depth} text-sm leading-normal text-label-assistive lg:text-base lg:font-semibold`}
                    >
                      디자인 시안 및 Back-end
                      <br />
                      Architecture 확인 / 협의
                    </p>
                    <p
                      className={`${styles.text_dot} ${styles.text_dot_benefit_accordion_2depth} text-sm leading-normal text-label-assistive lg:text-base lg:font-semibold`}
                    >
                      기술 스택 결정
                    </p>
                  </div>
                </dd>
                <dd
                  className={`${styles.text_dot} ${styles.text_dot_benefit_accordion} text-sm leading-normal text-label-assistive lg:text-base lg:font-semibold`}
                >
                  개발/구현
                  <div className="mt-1 flex flex-col gap-0.5">
                    <p
                      className={`${styles.text_dot} ${styles.text_dot_benefit_accordion_2depth} text-sm leading-normal text-label-assistive lg:text-base lg:font-semibold`}
                    >
                      웹 페이지 개발
                    </p>
                    <p
                      className={`${styles.text_dot} ${styles.text_dot_benefit_accordion_2depth} text-sm leading-normal text-label-assistive lg:text-base lg:font-semibold`}
                    >
                      API 연동 및 모니터링 기능 개발
                    </p>
                  </div>
                </dd>
                <dd
                  className={`${styles.text_dot} ${styles.text_dot_benefit_accordion} text-sm leading-normal text-label-assistive lg:text-base lg:font-semibold`}
                >
                  배포
                  <div className="mt-1 flex flex-col gap-0.5">
                    <p
                      className={`${styles.text_dot} ${styles.text_dot_benefit_accordion_2depth} text-sm leading-normal text-label-assistive lg:text-base lg:font-semibold`}
                    >
                      디버깅
                    </p>
                    <p
                      className={`${styles.text_dot} ${styles.text_dot_benefit_accordion_2depth} text-sm leading-normal text-label-assistive lg:text-base lg:font-semibold`}
                    >
                      반응형 대응
                    </p>
                    <p
                      className={`${styles.text_dot} ${styles.text_dot_benefit_accordion_2depth} text-sm leading-normal text-label-assistive lg:text-base lg:font-semibold`}
                    >
                      브라우저 테스트
                    </p>
                    <p
                      className={`${styles.text_dot} ${styles.text_dot_benefit_accordion_2depth} text-sm leading-normal text-label-assistive lg:text-base lg:font-semibold`}
                    >
                      배포
                    </p>
                  </div>
                </dd>
                <dd className="text-sm leading-normal text-label-assistive lg:text-base lg:font-semibold">
                  [프로젝트 완료 후]
                </dd>
                <div className="-mt-1 flex flex-col gap-0.5">
                  <dd
                    className={`${styles.text_dot} ${styles.text_dot_benefit_accordion} text-sm leading-normal text-label-assistive lg:text-base lg:font-semibold`}
                  >
                    이력서, 자기소개서, 포트폴리오 피드백
                  </dd>
                  <dd
                    className={`${styles.text_dot} ${styles.text_dot_benefit_accordion} text-sm leading-normal text-label-assistive lg:text-base lg:font-semibold`}
                  >
                    수료증 제공
                  </dd>
                  <dd
                    className={`${styles.text_dot} ${styles.text_dot_benefit_accordion} text-sm leading-normal text-label-assistive lg:text-base lg:font-semibold`}
                  >
                    추천서 제공(우수 수료자 대상)
                  </dd>
                </div>
              </div>
            </dl>
          </div>
        )}
      </li>
    </>
  )
}

export default BenefitAccordion
